import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import Header from 'components/Header';
import WarningMessageSmallScreen from 'components/WarningMessageSmallScreen';
import TabNavigation from 'components/TabNavigation';
import { useUserMe } from 'apiTyped/hooks/users.query';
import { isUserServicesList } from 'utils/routeAccess';
import { NEGOCE } from 'constants/routes';

const NegoceContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 20px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    max-width: calc(100vw - 15px);
    padding: 16px;
  }

  .navigation {
    margin: 20px 0;
  }
`;

const Negoce = (props) => {
  const { user } = useUserMe();

  const getNavigation = () => {
    return [
      {
        label: I18n.t('negoce.navigationOptions.submissions'),
        route: '/negociants-data/submissions'
      },
      {
        label: I18n.t('negoce.navigationOptions.synthesis'),
        route: '/negociants-data/synthesis'
      },
      {
        label: I18n.t('negoce.navigationOptions.pilotage_interne'),
        route: '/negociants-data/kpis'
      },
      {
        label: I18n.t('negoce.navigationOptions.presentation'),
        route: '/negociants-data/presentation'
      },
      {
        label: I18n.t('negoce.navigationOptions.rawData'),
        route: '/negociants-data/raw-data'
      }
    ];
  };

  const navigation = getNavigation();

  return (
    <NegoceContainer>
      <Header
        title={I18n.t('negoce.title')}
        subTitle={I18n.t('negoce.subTitle')}
      />
      {window.innerWidth > 845 ? (
        <React.Fragment>
          {isUserServicesList(user.services, NEGOCE.audit_de_place) && (
            <div className="navigation">
              <TabNavigation buttons={navigation} />
            </div>
          )}
          {props.children}
        </React.Fragment>
      ) : (
        <WarningMessageSmallScreen />
      )}
    </NegoceContainer>
  );
};

export default Negoce;
